<div class="od-alert" *ngIf="error" role="alert">
  <od-icon name="alert" [size]="16"></od-icon>
  <div class="od-alert-tx">
    <b>No se pudo traer la configuración</b>
    <p class="od-muted">{{ error }}</p>
  </div>
  <button type="button" class="od-btn od-btn-sm" (click)="cargar()">Reintentar</button>
</div>

<div aria-busy="true" *ngIf="cargando">
  <div class="od-skeleton" style="height: 190px; margin-bottom: 12px"></div>
  <div class="od-skeleton" style="height: 110px; margin-bottom: 12px"></div>
  <div class="od-skeleton" style="height: 190px"></div>
</div>

<ng-container *ngIf="cfg && !cargando">
  <p class="od-note" *ngIf="!puedeEditar"><od-icon name="lock"></od-icon> Solo lectura: puedes ver cómo está configurado, pero no cambiarlo.</p>

  <div style="display: grid; gap: 12px; max-width: 880px">
    <!-- Qué se le avisa a Odoo -->
    <section class="od-sec">
      <h5>Qué se le avisa a Odoo</h5>
      <div class="od-srow" *ngFor="let d of interruptores; trackBy: porCampo">
        <span class="od-tx"><b>{{ d.titulo }}</b><span class="od-muted">{{ d.ayuda }}</span></span>
        <button type="button" class="od-switch" role="switch" [attr.aria-checked]="cfg[d.campo]" [attr.aria-label]="d.titulo"
                [disabled]="!puedeEditar || ocupados.has(d.campo)" (click)="alternar(d, !cfg[d.campo])"></button>
      </div>
    </section>

    <!-- Archivo del día -->
    <section class="od-sec">
      <h5>Archivo del día</h5>
      <div class="od-srow">
        <span class="od-tx"><b>Hora de subida</b><span class="od-muted">A qué hora se arman y se suben los dos archivos.</span></span>
        <label class="od-select">
          <select aria-label="Hora de subida" [disabled]="!puedeEditar || ocupados.has('hora_subida')" (change)="cambiarHora($any($event.target).value)">
            <option *ngFor="let h of horas; trackBy: porHora" [value]="h.valor" [selected]="h.valor === cfg.hora_subida">{{ h.texto }}</option>
          </select>
        </label>
      </div>
      <div class="od-srow">
        <span class="od-tx"><b>Buzón</b><span class="od-muted">Dónde se dejan los archivos para que Odoo los tome.</span></span>
        <label class="od-select">
          <select aria-label="Buzón" [disabled]="!puedeEditar || ocupados.has('buzon_tipo')" (change)="cambiarBuzon($any($event.target).value)">
            <option value="local" [selected]="cfg.buzon_tipo === 'local'">Local</option>
            <option value="drive" [selected]="cfg.buzon_tipo === 'drive'">Google Drive</option>
          </select>
        </label>
      </div>
      <div class="od-srow" *ngIf="cfg.buzon_tipo === 'drive'">
        <span class="od-tx"><b>Carpeta de Google Drive</b><span class="od-muted">El identificador de la carpeta donde se dejan los archivos.</span></span>
        <label class="od-input" style="width: 320px"><input type="text" [(ngModel)]="carpeta" [disabled]="!puedeEditar" aria-label="Carpeta de Google Drive" autocomplete="off"></label>
        <button type="button" class="od-btn od-btn-sm" *ngIf="puedeEditar" [disabled]="ocupados.has('drive_folder_id') || carpeta.trim() === (cfg.drive_folder_id || '')" (click)="guardarCarpeta()">Guardar</button>
      </div>
    </section>

    <!-- Conexión con Odoo -->
    <section class="od-sec">
      <h5>Conexión con Odoo</h5>
      <div class="od-alert" *ngIf="claveVencePronto" role="alert" style="margin-top: 8px">
        <od-icon name="alert" [size]="16"></od-icon>
        <div class="od-alert-tx">
          <b>La clave de Odoo vence {{ textoVence }}</b>
          <p class="od-muted">Pide una nueva a 3MIT y guárdala aquí antes de que venza.</p>
        </div>
      </div>
      <div class="od-srow">
        <span class="od-tx"><b>Dirección</b></span>
        <label class="od-input" style="width: min(320px, 100%)"><input type="url" [(ngModel)]="url" [disabled]="!puedeEditar" placeholder="https://odoo.ejemplo.com" aria-label="Dirección" autocomplete="off"></label>
      </div>
      <div class="od-srow">
        <span class="od-tx"><b>Usuario</b></span>
        <label class="od-input" style="width: min(320px, 100%)"><input type="text" [(ngModel)]="usuario" [disabled]="!puedeEditar" aria-label="Usuario" autocomplete="off"></label>
      </div>
      <div class="od-srow">
        <span class="od-tx"><b>Clave</b></span>
        <label class="od-input" style="width: min(320px, 100%)"><input type="password" [(ngModel)]="clave" [disabled]="!puedeEditar" autocomplete="new-password" aria-label="Clave"
               [placeholder]="cfg.tiene_clave ? 'Déjala vacía para conservar la actual' : 'Escribe la clave'"></label>
      </div>
      <div class="od-srow" style="flex-wrap: wrap">
        <span class="od-tx" style="min-width: 220px">
          <ng-container *ngIf="cfg.conexion; else sinProbar">
            <span class="od-badge od-badge-solid" *ngIf="cfg.conexion.ok"><od-icon name="check" [size]="12"></od-icon>Conectado</span>
            <span class="od-badge od-badge-problem" *ngIf="!cfg.conexion.ok"><od-icon name="alert" [size]="12"></od-icon>Sin conexión</span>
            <span class="od-muted" style="font-size: 12px; display: block; margin-top: 2px">Probada el {{ cfg.conexion.probado_en | odooFecha }}<ng-container *ngIf="!cfg.conexion.ok"> · {{ cfg.conexion.mensaje }}</ng-container></span>
          </ng-container>
          <ng-template #sinProbar><span class="od-badge od-badge-dash">Sin probar</span></ng-template>
          <span class="od-muted" style="font-size: 12px; display: block" *ngIf="cfg.credencial_dias !== null && cfg.credencial_dias !== undefined">
            La clave vence en {{ cfg.credencial_dias }} {{ cfg.credencial_dias === 1 ? 'día' : 'días' }}
          </span>
        </span>
        <button type="button" class="od-btn" *ngIf="puedeEditar" [disabled]="guardandoConexion" (click)="guardarConexion()">{{ guardandoConexion ? 'Guardando…' : 'Guardar conexión' }}</button>
        <button type="button" class="od-btn od-btn-primary" *ngIf="puedeEditar" [disabled]="probando" (click)="probar()">
          <od-icon name="refresh" [class.od-spin]="probando"></od-icon>{{ probando ? 'Probando…' : 'Probar conexión' }}
        </button>
      </div>
    </section>
  </div>
</ng-container>
